import { Box, Table, Text } from "@mantine/core";
import { DetailCard } from "../detail-card";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { ReturnAnalyticsApi } from "../../../apis";
import RenderText from "../../ui/render-text";

interface IProps {
  dateFromIso?: string;
  dateToIso?  : string;
}

export function RepeatReturnersCard({ dateFromIso, dateToIso }: IProps) {
  const { t } = useTranslation("returns");
  const { data } = useSWR(
    ["returns.repeat-returners", dateFromIso, dateToIso],
    () => ReturnAnalyticsApi.repeatReturners({ dateFrom: dateFromIso, dateTo: dateToIso, limit: 8 }),
    { revalidateOnFocus: false }
  );

  const buyers = data?.buyers ?? [];

  return (
    <DetailCard
      title={t("dashboard.repeatReturners.title")}
      extra={data?.threshold ? (
        <Text size="sm" c="dimmed">{t("dashboard.repeatReturners.threshold", { count: data.threshold })}</Text>
      ) : null}
    >
      {buyers.length === 0 ? (
        <Box py="lg" ta="center">
          <Text c="dimmed" size="sm">{t("common.noData")}</Text>
        </Box>
      ) : (
        <Table verticalSpacing="xs" highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("col.buyer")}</Table.Th>
              <Table.Th ta="right">{t("col.count")}</Table.Th>
              <Table.Th ta="right">{t("col.totalReturns")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {buyers.map((b) => (
              <Table.Tr key={b.buyerBusinessId}>
                <Table.Td>
                  <RenderText text={b.buyerBusinessName ?? "—"} size="sm" fontWeight={500} lineClamp={1} />
                </Table.Td>
                <Table.Td ta="right">
                  <RenderText isAmount text={`${b.returnCount}`} size="sm" fontWeight={700} />
                </Table.Td>
                <Table.Td ta="right">
                  <RenderText isAmount text={`${b.totalRefundAmount.toLocaleString("mn-MN")} ₮`} size="sm" />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </DetailCard>
  );
}
